import {
  StyledMetricsInspection,
  StyledChartsRow,
  StyledTableContainer,
  StyledMetricChartWrapper,
  StyledScatterChartWrapper
} from './MetricsInspection.style';
import MetricsInspectionProvider from './state/Provider';
import Header from './Header/Header';
import AreaChart from './Charts/AreaChart';
import ScatterChart from './Charts/ScatterChart';
import ActivityTable from './ActivityTable';

const MetricsInspection = ({ widget, period, filters, isPublic }) => {
  return (
    <MetricsInspectionProvider
      widget={widget}
      period={period}
      filters={filters}
      isPublic={isPublic}
    >
      <StyledMetricsInspection data-cy='styled-metrics-inspection'>
        <Header />

        <StyledChartsRow data-cy='styled-charts-row'>
          <StyledMetricChartWrapper data-cy='styled-metric-chart-wrapper'>
            <AreaChart />
          </StyledMetricChartWrapper>
          <StyledScatterChartWrapper data-cy='styled-scatter-chart-wrapper'>
            <ScatterChart />
          </StyledScatterChartWrapper>
        </StyledChartsRow>

        <StyledTableContainer data-cy='styled-table-container'>
          <ActivityTable />
        </StyledTableContainer>
      </StyledMetricsInspection>
    </MetricsInspectionProvider>
  );
};

export default MetricsInspection;
